<div class="top-section">
    <h5 class="heading mb-0">{{ mode() === 'PAST' ? ss.t('pastView_title') : ss.t('futureView_title') }}
    </h5>
    <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
</div>

<div class="body-section position-relative ri-w-full">
    <div class="list-items-block ri-w-full">
        <div class="category-item ri-px-4 ri-py-4 ri-w-full">
            <div class="flex justify-between ri-w-full">
                <button (click)="$event.stopPropagation();" class="outline-none">
                    <span class="ri-me-6 text-14-400 color-8">{{ ss.t('viewConfiguration_emptyDays') }}</span>
                </button>
                <app-input-toggle [signal]="emptyDaysToggle" (toggle)="toggleEmptyDays()"></app-input-toggle>
            </div>
        </div>
        <div class="category-item ri-px-4 ri-py-4 ri-w-full" *ngIf="showInvalidEntryToggle()">
            <div class="flex justify-between ri-w-full">
                <button (click)="$event.stopPropagation();" class="outline-none">
                    <span class="ri-me-6 text-14-400 color-8">{{ ss.t('viewConfiguration_invalidEntry') }}</span>
                </button>
                <app-input-toggle [signal]="invalidEntryToggle" (toggle)="toggleInvalidEntry()"></app-input-toggle>
            </div>
        </div>
        <div class="category-item ri-px-4 ri-py-4 ri-w-full">
            <div class="flex justify-between ri-w-full">
                <button class="outline-none" (click)="$event.stopPropagation();">
                    <div class="ri-me-6">
                        <span class="text-14-400 color-8 flex">{{ ss.t('common_groupBy') }}</span>
                        <!-- Grouped view type options: collapsedView and showCounts -->
                        <!-- Visible for both date and hashtag grouping -->
                        <app-input-dropdown class="ri-pt-6px" [multiple]="true" [signal]="groupedViewTypeSignal()"
                            [config]="vs.groupedViewTypeConfig()" (select)="ss.updateView()"
                            textClass="text-16-400"></app-input-dropdown>
                    </div>
                </button>
                <!-- Group by: Past has date and hashtag options, Future is date only -->
                <app-input-dropdown [signal]="groupBySignal()" [config]="groupByConfig()" (select)="ss.updateView()"
                    textClass="text-16-400 whitespace-nowrap"></app-input-dropdown>
            </div>

        </div>
        <div class="category-item ri-px-4 ri-py-4 ri-w-full">
            <button (click)="$event.stopPropagation()">
                <app-kebab-show-menu textClass="text-16-400" [signal]="showSignal()" [config]="entityShowConfig()"
                    [multiple]="true" (selectNested)="ss.updateView()" [hiddenValues]="hiddenValues()"
                    [colorClass]="'color-35'" [placeholder]="ss.t('common_kebabMenuViewConfiguration')"
                    [placeholderColor]="'color-8'" (select)="ss.updateView()" role="button"
                    [kebabShowPanelClass]="cc.isNarrowScreen() ? 'commonbottomSheetClass' : ''">
                </app-kebab-show-menu>
            </button>
        </div>
    </div>
</div>